// extracted by mini-css-extract-plugin
export default {"wrapper":"Tags_wrapper__vD8-n","tag":"Tags_tag__gbMk-"};